import type { ReactNode } from "react";

type SectionProps = {
  id?: string;
  eyebrow?: string;
  title?: string;
  intro?: string;
  children?: ReactNode;
  dark?: boolean;
  className?: string;
};

export function Section({ id, eyebrow, title, intro, children, dark = false, className = "" }: SectionProps) {
  return (
    <section id={id} className={`section-pad ${dark ? "petrol-section" : ""} ${className}`}>
      <div className="container-grid">
        {(eyebrow || title || intro) && (
          <div className="mb-9 max-w-[720px]">
            {eyebrow && <p className={`${dark ? "eyebrow-sage" : "eyebrow"} mb-4`}>{eyebrow}</p>}
            {title && <h2 className="text-balance text-3xl font-bold leading-[1.06] md:text-[2.6rem]">{title}</h2>}
            {intro && <p className={`mt-5 text-lg leading-8 ${dark ? "text-brand-darkMuted" : "text-ink-secondary"}`}>{intro}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
